import * as React from "react";
import DailyCasesChart from "../../../../../../ui-library/daily-cases-chart/daily-cases-chart";
import { keysToPlotActive } from "../../graph-keys";
import { CovidCaseByCountry_covidCaseOwidByCountry_data } from "../../../../../../../apollo-types/CovidCaseByCountry";
import ItemPicker from "../../../../../../ui-library/item-picker/item-picker";
import { EventCategory } from "../../../../../../../utils/analytics";
import { LatestCovidCasesResult } from "../../../../../../../types/latest-covid-cases";
import RankActiveCases from "./ranks/rank-active-cases";

interface ActiveCasesContentProps {
  covidData?: CovidCaseByCountry_covidCaseOwidByCountry_data[] | null;
  latestCovidCases?: LatestCovidCasesResult;
}

const displayTypes = ["Active by country", "Active over time"];

const ActiveCasesContent: React.FC<ActiveCasesContentProps> = ({
  covidData,
  latestCovidCases,
}) => {
  const [activeTab, setActiveTab] = React.useState<string>(displayTypes[0]);

  return (
    <>
      <ItemPicker
        itemPickerName="totalActivePicker"
        isUniWidth={true}
        isScrollable={true}
        items={displayTypes.map((t) => ({
          label: t,
          value: t,
        }))}
        activeItemValue={activeTab}
        onItemClick={setActiveTab}
        eventCategory={EventCategory.GlobalSituation}
      />
      {covidData ? (
        <div
          style={{ display: activeTab === displayTypes[1] ? "block" : "none" }}
        >
          <DailyCasesChart data={covidData} keysToPlot={keysToPlotActive} />
        </div>
      ) : null}

      <div
        style={{ display: activeTab === displayTypes[0] ? "block" : "none" }}
      >
        <RankActiveCases latestCovidCases={latestCovidCases} />
      </div>
    </>
  );
};

export default ActiveCasesContent;
